namespace $.$$ {
	$mol_style_define( $shm_showcase_preview, {
		width: '10rem',
		alignItems: 'center',
		Chart: { width: '100%', height: '4rem', Plot: { minHeight: 0 } },
		Form: { width: '10rem' },
		Form_input: { minWidth: 0, width: '100%' },
		File_drop: { width: '100%', height: '4rem', aspectRatio: 'auto', flex: { direction: 'row' } },
		Stack_front: { justifySelf: 'end', alignSelf: 'end' },
		Echarts: { position: 'relative', width: '100%', height: '3rem' },
		Frame: { height: '3rem', aspectRatio: 'auto' },
		Scroll: { height: '4rem', width: '100%' },
		Search: { minWidth: 0, width: '100%', Anchor: { minWidth: 0, width: '100%' }, Query: { minWidth: 0, width: 0 } },
		Textarea: { minWidth: 0, width: '100%' },
		String: { minWidth: 0, width: '100%' },
		Format: { minWidth: 0, width: '100%' },
		Number: { minWidth: 0, maxWidth: '100%', String: { minWidth: 0, width: '4rem' } },
		Portion: { width: '100%' },
	} )
}
